import { render, staticRenderFns } from "./LearnerMarksheetIsceITOIII.vue?vue&type=template&id=28f77776&scoped=true&"
import script from "./LearnerMarksheetIsceITOIII.vue?vue&type=script&lang=js&"
export * from "./LearnerMarksheetIsceITOIII.vue?vue&type=script&lang=js&"
import style0 from "./LearnerMarksheetIsceITOIII.vue?vue&type=style&index=0&id=28f77776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f77776",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VRow,VSnackbar})
